import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`熱衷於程式語言學習與技藝提升，致力於將企業架構、精實需求管理、領域驅動設計與微服務架構完美結合,打造企業導向的業務中台；致力於將資料倉儲、即時串流處理、機器學習與高效能儲存完美結合,打造行業導向的智慧型資料中台。《軟體設計精要與模式》《解構領域驅動設計》作者。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      